import React from 'react';
import * as mobxReact from 'mobx-react';
import { IOperatorDetailsDTO } from '../../../api/rooms.dao';
import './operator-column.scss';
import ColumnWithCheckbox from '../column-with-checkbox/column-with-checkbox';
import { OperatorStatus } from '../../../api/control.dao';
import Text from '../text/text';
import { CollapsedOperators } from './collapsed-operators';

interface IProps {
    operators: IOperatorDetailsDTO[];
    withGreyedCheckMark?: boolean;
    isCollapsed?: boolean;
    searchValue?: string;
}

const OperatorColumn = mobxReact.observer((props: IProps) => {
    const {
        operators,
        isCollapsed,
        searchValue
    } = props;
    const sortedOperators = operators.slice().sort((a, b) => a.lastName.localeCompare(b.lastName));

    if (isCollapsed) {
        return <CollapsedOperators
                    operators={sortedOperators}
                    searchValue={searchValue}
                />;
    }

    return (
        <>
            {
                sortedOperators.map((operator, index) => {
                    const fullName = operator.firstName + ' ' + operator.lastName;

                    return (

                        <ColumnWithCheckbox
                            isActive={operator.operatorStatus === OperatorStatus.READY}
                            key={operator.operatorId ? operator.operatorId : `${operator.firstName} ${operator.lastName} ${index}`}
                            withGreyedCheckMark={props.withGreyedCheckMark}
                        >
                            <div className='operator-list-item__text' key={operator.operatorId}>
                                <Text message={fullName} highlightValue={props.searchValue} withEllipsis withHighlight />
                            </div>
                        </ColumnWithCheckbox>
                    );
                })
            }
        </>
    );
});

export default OperatorColumn;
